import "./styles.scss";

import React from "react";

import SimpleCard from "components/SimpleCard";
import Pagination from "components/Pagination";

import { getColorVariant } from "utils";

const Grid = ({ list, pageContext, no_pagination }) => {
  const isEmpty = !list?.length > 0;

  return (
    <section className="blog-main__grid">
      {!isEmpty && (
        <>
          <div className="row">
            {list.map((item, index) => (
              <div key={index} className="col-lg-4 col-sm-6">
                <SimpleCard
                  url={item.uri}
                  image={item.featuredImage?.node?.sourceUrl}
                  title={item?.title}
                  description={item?.excerpt.replace(/<\/?p>/g, "")}
                  variant={getColorVariant(index + 1)}
                  isEqual
                />
              </div>
            ))}
          </div>
        </>
      )}
      {!!!no_pagination && <Pagination {...pageContext} />}
    </section>
  );
};

export default Grid;
